import { render } from "./Refund.vue?vue&type=template&id=0d987c56&scoped=true"
import script from "./Refund.vue?vue&type=script&lang=js"
export * from "./Refund.vue?vue&type=script&lang=js"

import "./Refund.vue?vue&type=style&index=0&id=0d987c56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d987c56"

export default script